import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { AppService } from "src/app/app.service";
import { LineItemModalComponent } from "src/app/shared/line-item-modal/line-item-modal.component";
import { LineItemMonitorDataService } from "../line-item-monitor-data.service";
import {
  AddColTableData,
  SuggestedLineItems,
} from "../line-item-monitor.model";

@Component({
  selector: "app-line-item-edit-modal",
  templateUrl: "./line-item-edit-modal.component.html",
  styleUrls: ["./line-item-edit-modal.component.scss"],
})
export class LineItemEditModalComponent implements OnInit {
  @Input() addColTableData: Array<AddColTableData>;
  @Input() ticker: string;
  @Input() max: number;
  @Input() maxHeight: string;
  @Input() stdLineItems: Array<SuggestedLineItems>;
  @Input() isLIMModal = true;
  @Input() marketItemsData: Array<any>;
  @Output() updateComp = new EventEmitter();
  @Output() save = new EventEmitter();
  @Output() close = new EventEmitter();
  isSaveDisabled: boolean;
  isLoading: boolean;

  @ViewChild(LineItemModalComponent)
  lineItemModalComponent: LineItemModalComponent;

  constructor(
    private dataService: LineItemMonitorDataService,
    private appService: AppService,
  ) {}

  ngOnInit() {
    this.onUpdateLineItems(this.addColTableData);
  }

  onUpdateLineItems(data) {
    this.isSaveDisabled = data.length === 0 || data.length > 100;
  }
  restoreDefault() {
    this.isLoading = true;
    this.dataService.getLimDefaultLines(this.ticker).subscribe((data: any) => {
      this.addColTableData = data.data.line_items.map((row) => {
        /**
         * 1. copy header data to name as remove-model-section need name key
         * 2. line-item-modal component uses sli_id, so items added from add-modal-section has sli_id
         * and existing line items from remove-modal-section(which uses addColTableData) have dapparameterid,
         * so to keep it consistent - adding sli_id here as well.
         */
        return { ...row, name: row.header, sli_id: row.dapparameterid };
      });
      this.onUpdateLineItems(this.addColTableData);
      this.isLoading = false;
    });
  }

  closeEditModal() {
    this.close.emit();
  }
  saveLineItems() {
    const modalData = this.lineItemModalComponent.modalData;
    this.save.emit(modalData);
  }
}
